import React, { useState } from 'react';
import * as Yup from 'yup';
import { Formik } from 'formik';
import './lang-update-form.scss'
import { updateLanguage } from '../../../services/users';
import { toast } from 'react-toastify';
import BeatLoader from "react-spinners/BeatLoader";
import Constant from "../../../Constant";

const orderSchema = Yup.object().shape({
  pin: Yup.string()
    .required('PIN is required')
    .min(5, 'PIN must be exactly 5 characters')
    .max(5, "PIN must be exactly 5 characters")
    .matches(
      /^([a-zA-Z0-9]){0,5}/,
      'PIN should be alphanumeric. No special characters allowed'
    ),
    language: Yup.string()
    .required('Field is required')
    .trim()
});

const LanguageUpdateForm = ({ userId, lang }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [language, setLanguage] = useState("English");
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  const handleSubmit = (values) => {
    setIsLoading(true);
    console.log(`Submitting the following data ${JSON.stringify(values)}`);
    updateLanguage(values).then(res => {
      if(res.status_code == 200 || res.status_code == 201) {
        toast(`${res.message}. You can close this page and return to the app`);
        setMessage(`${res.message}. You can close this page and return to the app`);
      }else {
        toast(`Sorry! ${res.message}`);
        setErrorMessage(res.message);
      }
    }).catch(err => {
      toast(`Sorry, ${err.message}`)
      setErrorMessage(err.message);
    }).finally( () => {
      setIsLoading(false);
      setFormSubmitted(true);
    })
  };

  return  (
    <div className="login-form">
      <div className="login-error">{ errorMessage ? errorMessage : ''}</div>
      <div className='login-info'><h2>AFTA WALLET</h2></div>
      { !formSubmitted &&
        <Formik
        initialValues={{
          pin: "",
          id: userId,
          language: language
        }}
        onSubmit={(values) => {
          values.language = language;
          handleSubmit(values);
        }}
        validationSchema={orderSchema}
        >
        {({ handleSubmit, values, handleChange, errors, touched }) => (
          <form onSubmit={handleSubmit}>
            
            <div className={`field`}>
              <p>Update Your language preference.</p>
            </div>
            <div className={`field`}>
              <label htmlFor="language_pref">Select Language</label>
              <select 
                name={`language`}
                id={`language`} 
                value={`${language}`} 
                onChange={event => setLanguage(event.target.value)} 
                className="__form-input">
                  <option value="english">English</option>
                  <option value="french">Français</option>
              </select>
              {errors.language && touched.language ? (
                <div className="error">{errors.language}</div>
                ) : null
              }
            </div>
            <div className={`field`}>
              <label htmlFor="pin">PIN code</label>
              <input
                type='password'
                name="pin"
                id="pin"
                placeholder="Votre code PIN"
                value={values.pin}
                onChange={handleChange}
              />
              {errors.pin && touched.pin ? (
                <div className="error">{errors.pin}</div>
              ) : null}
            </div>
            <button type="submit" disabled={isLoading}>
              {!isLoading && <span>CONFIRMER</span>}
              {/* {isLoading && <span>Sending ...</span>} */}
              <BeatLoader
                color={Constant.spinner_color}
                loading={isLoading}
                cssOverride={{
                  textAlign: 'center',
                  marginTop: '20px'
                }}
              />
              {/* {isLoading && <Loader />} */}
            </button>
          </form>
        )}
        </Formik>
      }
      {
        formSubmitted && 
        <p className='login-info'>
          {message}
        </p>
      }
    </div>
  );
};

export default LanguageUpdateForm;
